import { render, staticRenderFns } from "./IndividualRelationValues.vue?vue&type=template&id=78706c66"
import script from "./IndividualRelationValues.vue?vue&type=script&lang=ts"
export * from "./IndividualRelationValues.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports